module.exports = __webpack_public_path__ + "img/高位料箱AGV.d5768697.jpg";